<style lang='less' scoped>
.main {
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  background: #f3f3f3;
  .check-list {
    position: relative;
    background: #fff;
    border-radius: 8px;
    width: 100%;
    height: auto;
    padding: 20px 30px;
    box-sizing: border-box;
    .header {
      width: 100%;
      height: 48px;
    }
    .content {
      width: 100%;
    }
    .footer {
      width: 100%;
      padding: 20px 0;
      box-sizing: border-box;
    }
  }
  .upload-file {
    position: relative;
    background: #fff;
    border-radius: 8px;
    width: 100%;
    height: auto;
    padding: 20px 30px;
    box-sizing: border-box;
    .header {
      width: 100%;
      display: flex;
      line-height: 31px;
      .empty-box {
        width: 8px;
      }
    }
    .content {
      width: 100%;
      height: auto;
      padding: 20px 0;
      box-sizing: border-box;
      background: #fff;
      .tab-tips {
        width: 100%;
        height: 48px;
        font-size: 16px;
        line-height: 48px;
        display: flex;
        margin-bottom: 20px;
        .introduce {
          width: 160px;
          height: 100%;
          span {
            color: rgb(241, 33, 33);
          }
        }
        .creatButton {
          width: 72px;
          height: 36px;
        }
      }
      .upload-video {
        width: 100%;
        height: auto;
        font-size: 16px;
        line-height: 48px;
        display: flex;
        margin-bottom: 20px;
        .introduce {
          width: 160px;
          height: 100%;
          span {
            color: rgb(241, 33, 33);
          }
        }
      }
    }
  }
}
</style>
<template>
  <div class="main">
    <div class="check-list" v-show="creatNew">
      <div class="header">
        <i-button type="primary" class="loginButton" @click="AddNew">上传</i-button>
      </div>
      <div class="content">
        <i-table border :columns="materialColumns" :data="materList"/>
      </div>
      <div class="footer">
        <Page
          :total="count"
          :page-size="pageSize"
          :page-size-opts="[10,20]"
          show-total
          @on-change="ChangePage"
          @on-page-size-change="ChangePageSize"
          show-elevator
          show-sizer
        />
      </div>
    </div>
    <div class="upload-file" v-show="upMyContent">
      <div class="header">
        <Button @click="Reback" type="primary">
          <Icon type="ios-arrow-back" />返回
        </Button>
        <div class="empty-box"/>|
        <div class="empty-box"/>上传文件
      </div>
      <div class="content">
        <div class="tab-tips">
          <div class="introduce">
            <span>*</span>出版社名称：
          </div>
          <i-input
            v-model="new_material_name"
            placeholder="请输入..."
            style="width: 280px;margin-top:8px;height: 36px;"
          />
        </div>
        <div class="tab-tips">
          <div class="introduce">
            <span>*</span>教材名称
          </div>
          <i-input
            v-model="new_publish_name"
            placeholder="请输入..."
            style="width: 280px;margin-top:8px;height: 36px;"
          />
        </div>
        <div class="tab-tips">
          <div class="introduce">
            <span>*</span>上传形式
          </div>
          <Radio-group v-model="fileType">
            <Radio @on-change="ChooseVideo" label="1">视频</Radio>
            <Radio @on-change="ChooseAudio" label="2">PDF+音频</Radio>
          </Radio-group>
        </div>
        <!-- 上传视频 -->
        <div class="upload-video" v-show="fileType==1">
          <div class="introduce">
            <span>*</span>上传视频
          </div>
          <Upload type="drag" :before-upload="AddVideo" accept=".mp4, .avi, .rmvb" action>
            <div style="padding: 20px 0;width: 280px;">
              <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"/>
              <p>单击或拖动文件以上传</p>
            </div>
          </Upload>
        </div>
        <div class="upload-video" v-show="fileType==2">
          <div class="introduce">
            <span>*</span>上传PDF
          </div>
          <Upload type="drag" :before-upload="AddPdf" accept=".pdf" action>
            <div style="padding: 20px 0;width: 280px;">
              <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"/>
              <p>单击或拖动文件以上传</p>
            </div>
          </Upload>
        </div>
        <div class="upload-video" v-show="fileType==2">
          <div class="introduce">
            <span>*</span>上传音频
          </div>
          <Upload type="drag" :before-upload="AddAudio" accept=".mp3" action>
            <div style="padding: 20px 0;width: 280px;">
              <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"/>
              <p>单击或拖动文件以上传</p>
            </div>
          </Upload>
        </div>
        <!-- 确定上传 -->
        <div class="tab-tips">
          <div class="introduce"/>
          <i-button type="primary" class="creatButton" @click="Uplode">确定</i-button>
        </div>
      </div>
    </div>
    <div class="upload-file" v-show="changeMyContent">
      <div class="header">
        <Button @click="Reback" type="primary">
          <Icon type="ios-arrow-back" />返回
        </Button>
        <div class="empty-box"/>|
        <div class="empty-box"/>编辑文件
      </div>
      <div class="content">
        <div class="tab-tips">
          <div class="introduce">
            <span>*</span>出版社名称：
          </div>
          <i-input
            v-model="new_material_name"
            placeholder="请输入..."
            style="width: 280px;margin-top:8px;height: 36px;"
          />
        </div>
        <div class="tab-tips">
          <div class="introduce">
            <span>*</span>教材名称
          </div>
          <i-input
            v-model="new_publish_name"
            placeholder="请输入..."
            style="width: 280px;margin-top:8px;height: 36px;"
          />
        </div>
        <div class="tab-tips">
          <div class="introduce">
            <span>*</span>上传形式
          </div>
          <Radio-group v-model="fileType">
            <Radio @on-change="ChooseVideo" label="1">视频</Radio>
            <Radio @on-change="ChooseAudio" label="2">PDF+音频</Radio>
          </Radio-group>
        </div>
        <!-- 上传视频 -->
        <div class="upload-video" v-show="fileType==1">
          <div class="introduce">
            <span>*</span>上传视频
          </div>
          <Upload type="drag" :before-upload="AddVideo" accept=".mp4, .avi, .rmvb" action>
            <div style="padding: 20px 0;width: 280px;">
              <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"/>
              <p>单击或拖动文件以上传</p>
            </div>
          </Upload>
        </div>
        <div class="upload-video" v-show="fileType==2">
          <div class="introduce">
            <span>*</span>上传PDF
          </div>
          <Upload type="drag" :before-upload="AddPdf" accept=".pdf" action>
            <div style="padding: 20px 0;width: 280px;">
              <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"/>
              <p>单击或拖动文件以上传</p>
            </div>
          </Upload>
        </div>
        <div class="upload-video" v-show="fileType==2">
          <div class="introduce">
            <span>*</span>上传音频
          </div>
          <Upload type="drag" :before-upload="AddAudio" accept=".mp3" action>
            <div style="padding: 20px 0;width: 280px;">
              <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"/>
              <p>单击或拖动文件以上传</p>
            </div>
          </Upload>
        </div>
        <!-- 确定上传 -->
        <div class="tab-tips">
          <div class="introduce"/>
          <i-button type="primary" class="creatButton" @click="EditUplode">确定修改</i-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import contentApi from '@/lib/api/content'
import utilsTool from '@lib/utils'
export default {
  name: '',
  data() {
    return {
      creatNew: true,
      upMyContent: false,
      changeMyContent: false, // 编辑作品开关
      count: 0,
      start: 0,
      pageSize: 10,
      editContentId: '', // 编辑素材的id
      ChooseType: true, // 选择上传类型开关
      fileType: '', // 上传文件类型
      new_material_name: '',
      new_publish_name: '',
      materialColumns: [
        {
          title: '提交ID',
          key: 'id'
        },
        {
          title: '出版社',
          key: 'publishName'
        },
        {
          title: '教材名称',
          key: 'materialName'
        },
        {
          title: '时间',
          key: 'dateTime'
        },
        {
          title: '提交状态',
          key: 'taskType'
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'center',
          render: (h, params) => {
            console.log(params)
            const editBtn = h('i-button', {
              on: {
                click: () => {
                  this.Show(params.row.id)
                }
              },
              props: {
                type: 'primary'
              }
            }, '编辑')

            if (params.row.status == 1) {
              return h('div', {
              }, [editBtn])
            }
          }
        }
      ],
      materList: [],
      materialData: [],
      videoList: [],
      audioList: [],
      pdfList: [],
      videoUrlList: [],
      audioUrlList: [],
      pdfUrlList: []
    }
  },
  created() {
    this.GetList()
  },
  methods: {
    AddNew() {
      this.creatNew = false
      this.upMyContent = true
      this.changeMyContent = false
    },
    // 选择视频
    ChooseVideo() {
      this.ChooseType = true
    },
    // 选择音频
    ChooseAudio() {
      this.ChooseType = false
    },
    Reback() {
      this.creatNew = true
      this.changeMyContent = false
      this.upMyContent = false
    },
    ChangePage(index) {
      this.start = (index - 1) * this.pageSize
      this.GetList()
    },
    ChangePageSize(pageSize) {
      this.pageSize = pageSize
      this.GetList()
    },
    // 上传
    Uplode() {
      contentApi.UploadFile({
        p_name: this.new_publish_name,
        m_name: this.new_material_name,
        type: this.fileType,
        videos: JSON.stringify(this.videoUrlList),
        pdfs: JSON.stringify(this.pdfUrlList),
        audios: JSON.stringify(this.audioUrlList)
      }).then(res => {
        if (res.status == 1) {
          this.$Message.info('添加成功')
          this.creatNew = true
          this.changeMyContent = false
          this.upMyContent = false
          this.videoUrlList = []
          this.pdfUrlList = []
          this.audioUrlList = []
          this.fileType = ''
          this.new_publish_name = ''
          this.new_material_name = ''
          this.GetList()
        } else {
          alert(res.msg)
        }
      })
    },
    // 编辑文件
    EditUplode() {
      contentApi.EditFile({
        id: this.editContentId,
        p_name: this.new_publish_name,
        m_name: this.new_material_name,
        type: this.fileType,
        videos: JSON.stringify(this.videoUrlList),
        pdfs: JSON.stringify(this.pdfUrlList),
        audios: JSON.stringify(this.audioUrlList)
      }).then(res => {
        if (res.status == 1) {
          this.$Message.info('修改成功')
          this.creatNew = true
          this.changeMyContent = false
          this.upMyContent = false
          this.videoUrlList = []
          this.pdfUrlList = []
          this.audioUrlList = []
          this.fileType = ''
          this.new_publish_name = ''
          this.new_material_name = ''
          this.editContentId = ''
          this.GetList()
        } else {
          alert(res.msg)
        }
      })
    },
    // 获取素材列表
    GetList() {
      contentApi
        .GetContentList({
          start: this.start,
          rows: this.pageSize
        })
        .then(res => {
          console.log(res)
          const materialInfo = res
          this.materialData = materialInfo.data.list
          this.count = materialInfo.data.count // 总条数
          this.materList = this.materialData.map((item) => {
            if (item.status == 1) {
              item.taskType = '自动转码中'
            } else if (item.status == 2) {
              item.taskType = '转码成功 '
            } else if (item.status == 3) {
              item.taskType = '失败 '
            }
            return {
              id: item.id,
              dateTime: item.date_time,
              publishName: item.publish_name,
              materialName: item.material_name,
              status: item.status,
              taskType: item.taskType
            }
          })
          console.log(this.materList)
        })
    },
    // 编辑教材
    Show(id) {
      this.editContentId = id
      this.changeMyContent = true
      this.creatNew = false
      this.upMyContent = false
    },
    AddVideo(file) {
      utilsTool.UploadFile({
        file,
        success: (res) => {
          this.videoList.push(file)
          this.videoUrlList.push({
            name: res.fileName,
            url: res.url
          })
          this.$Message.info('上传成功')
        },
        fail: (err) => {
          this.$Message.info(err)
          console.log(err)
        }
      })
      return false
    },
    RemoveVideo(index) {
      this.videoList.splice(index, 1)
      this.videoUrlList.splice(index, 1)
    },
    AddAudio(file) {
      utilsTool.UploadFile({
        file,
        success: (res) => {
          this.audioList.push(file)
          this.audioUrlList.push(
            {
              name: res.fileName,
              url: res.url
            }
          )
          this.$Message.info('上传成功')
        },
        fail: (err) => {
          this.$Message.info(err)
          console.log(err)
        }
      })
      return false
    },
    RemoveAudio(index) {
      this.audioList.splice(index, 1)
      this.audioUrlList.splice(index, 1)
    },
    AddPdf(file) {
      utilsTool.UploadFile({
        file,
        success: (res) => {
          this.pdfList.push(file)
          this.pdfUrlList.push(
            {
              name: res.fileName,
              url: res.url
            }
          )
          this.$Message.info('上传成功')
        },
        fail: (err) => {
          this.$Message.info(err)
          console.log(err)
        }
      })
      return false
    },
    RemovePdf(index) {
      this.pdfList.splice(index, 1)
      this.pdfUrlList.splice(index, 1)
    }
  }
}
</script>
